import React from "react";
import { Route, Routes } from "react-router-dom";
import User from "../Pages/Masters/Roles and Permissions/User";
import Facility from "../Pages/Masters/Facility Master/Facility";
import ListIndustrialProcess from "../Pages/Masters/Scope1/IndustrialMaster/IndustrialProcess/ListIndustrialProcess";
import ListEquipment from "../Pages/Masters/Scope1/IndustrialEquipment/ListEquipment";
import Scope1LogisticsVendorMaster from "../Pages/Masters/Scope1/LogisticsVendor/Scope1LogisticsVendorMaster";
import Scope1Vehicle from "../Pages/Masters/Scope1/VehicalMaster/Scope1Vehicle";
import Machinery from "../Pages/Masters/Scope1/Machinery Master/Machinery";
import ElectricityEquipment from "../Pages/Masters/Scope2/ElectricityMaster/EquipmentMaster/ElectricityList";
import Equipment from "../Pages/Masters/Scope2/EquipmentMaster";
import VendorMaster from "../Pages/Masters/Scope2/VendorMaster/VendorMaster";
import Vehicle from "../Pages/Masters/Scope3/Transportation&Distribution/Vehicle/Vehicle";
import ListDriver from "../Pages/Masters/Scope3/Transportation&Distribution/DriverMaster/ListDriver";
import WasteData from "../Pages/Masters/Scope3/WasteManagement/WasteData";
import PurchasedGoods from "../Pages/Masters/Scope3/PurchasedGoods/PurchasedGoods";
import LeasedAssets from "../Pages/Masters/Scope3/LeasedAssets/LeasedAssets";
import Franchise from "../Pages/Masters/Scope3/Franchise/Franchise";
import Investment from "../Pages/Masters/Scope3/Investment/Investment";
import TransportationLogisticVendor from "../Pages/Masters/Scope3/Transportation&Distribution/LogisticVendorMaster/LogisticsVendorMaster";
import ElectricityVendor from "../Pages/Masters/Scope2/ElectricityMaster/VendorMaster/VendorMaster";
import EquipmentList from "../Pages/Masters/Scope2/HeatMaster/EquipmentMaster/EquipmetList";
import HeatVendorMaster from "../Pages/Masters/Scope2/HeatMaster/VendorMaster/Vendor";
import ProductMaster from "../Pages/Masters/Scope1/ProductMaster/List";
import CompanyAdmin from "../Pages/Masters/Company Admin/ListAdmin";
// import Calendary from "../Pages/Calendary";

export const MastersRoutes = [
  { path: "/setup/roles-permission", element: <User /> },
  { path: "/setup/facility-master", element: <Facility /> },
  {
    path: "/setup/masters/industrial-process",
    element: <ListIndustrialProcess />,
  },
  {
    path: "/setup/masters/scope1/industrial-equipment",
    element: <ListEquipment />,
  },
  {
    path: "/setup/masters/scope1/logistics-vendor-master",
    element: <Scope1LogisticsVendorMaster />,
  },
  {
    path: "/setup/masters/scope1/vehicle-master",
    element: <Scope1Vehicle />,
  },
  {
    path: "/setup/masters/scope1/machinery-master",
    element: <Machinery />,
  },
  { path: "/setup/masters/product-master", element: <ProductMaster /> },
  {
    path: "/setup/masters/scope2/electricity-master/equipment-master",
    element: <ElectricityEquipment />,
  },
  {
    path: "/setup/masters/scope2/electricity-master/vendor-master",
    element: <ElectricityVendor />,
  },
  {
    path: "/setup/masters/scope2/heat-master/equipment-master",
    element: <EquipmentList />,
  },
  {
    path: "/setup/masters/scope2/heat-master/vendor-master",
    element: <HeatVendorMaster />,
  },
  {
    path: "/setup/masters/scope2/steam-master/equipment-master",
    element: <Equipment />,
  },
  {
    path: "/setup/masters/scope2/steam-master/vendor-master",
    element: <VendorMaster />,
  },
  {
    path: "/setup/masters/scope3/transportation-distribution/logistics-vendor-master",
    element: <TransportationLogisticVendor />,
  },
  {
    path: "/setup/masters/scope3/transportation-distribution/vehicle-master",
    element: <Vehicle />,
  },
  {
    path: "/setup/masters/scope3/transportation-distribution/driver-master",
    element: <ListDriver />,
  },
  {
    path: "/setup/masters/scope3/waste-generated",
    element: <WasteData />,
  },
  {
    path: "/setup/masters/scope3/purchased-goods",
    element: <PurchasedGoods />,
  },
  {
    path: "/setup/masters/scope3/leased-assets",
    element: <LeasedAssets />,
  },
  {
    path: "/setup/masters/scope3/franchise-master",
    element: <Franchise />,
  },
  {
    path: "/setup/masters/scope3/investment-master",
    element: <Investment />,
  },
];
